module.exports = __webpack_public_path__ + "static/img/qcode.a67814a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qcode.png
// module id = EpGT
// module chunks = 8